import { useSearchParams } from 'react-router';
import { Box, TextField, Button, Typography, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import alpsBackground from '../assets/images/a1-sidebar-image.svg';
import logoWhite from '../assets/images/altvia-logo-white.svg';
import logoBlack from '../assets/images/altvia-logo-black.svg';

// Sign-in page for MCP (AI assistant) connections. The alps-be OAuth shim
// redirects here with a request_id; we post it back with the user's email as
// a plain form submit (full-page navigation) because the response is a
// cross-origin redirect into Cognito, which fetch/XHR cannot follow.
const McpSignin = () => {
	const theme = useTheme();
	const isDark = theme.palette.mode === 'dark';
	const logo = isDark ? logoWhite : logoBlack;

	const [searchParams] = useSearchParams();
	const requestId = searchParams.get('request_id');
	const error = searchParams.get('error');

	const formAction = `${process.env.REACT_APP_API_URL}/mcp/oauth/authorize`;

	return (
		<Grid container style={{ minHeight: '100vh', position: 'relative' }}>
			<Grid
				container
				alignItems='center'
				justifyContent='center'
				direction='column'
				size={{
					xs: 12,
					md: 6,
				}}
			>
				<Box width={300} display='flex' flexDirection='column'>
					<img src={logo} alt='Altvia Logo' style={{ marginBottom: 20 }} />
					<Typography variant='h6' style={{ marginBottom: 4 }}>
						Connect your AI assistant
					</Typography>
					<Typography
						variant='body2'
						color='textSecondary'
						style={{ marginBottom: 10 }}
					>
						Sign in with your Altvia account to connect Claude, ChatGPT, or
						another AI assistant to Launchpad.
					</Typography>
					{!requestId ? (
						<Typography variant='body2' color='error' style={{ marginTop: 10 }}>
							This sign-in link is invalid or has expired. Please restart the
							connection from your AI assistant.
						</Typography>
					) : (
						<form method='POST' action={formAction}>
							<input type='hidden' name='request_id' value={requestId} />
							<TextField
								label='Email'
								name='email'
								type='email'
								variant='outlined'
								margin='normal'
								autoFocus
								fullWidth
								required
							/>
							<Button
								type='submit'
								variant='contained'
								color='primary'
								style={{ marginTop: 20 }}
								fullWidth
							>
								CONTINUE
							</Button>
							{error === 'not_found' && (
								<Typography
									variant='body2'
									color='error'
									style={{ marginTop: 10 }}
								>
									No account found for that email. Please try again or contact
									your administrator.
								</Typography>
							)}
						</form>
					)}
				</Box>
			</Grid>
			<Grid
				style={{
					backgroundImage: `url(${alpsBackground})`,
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
					backgroundPosition: 'center top',
					position: 'relative',
				}}
				size={{
					xs: 12,
					md: 6,
				}}
			>
				<Box
					style={{
						position: 'absolute',
						top: 0,
						left: 0,
						width: '100%',
						height: '100%',
					}}
				/>
			</Grid>
		</Grid>
	);
};

export default McpSignin;
